import environmentConfigComponent from './environment_config.component';
import environmentConfigCreate from './create'
import environmentConfigEdit from './edit'
import environmentConfigAll from './all'

let environmentConfigModule = angular.module('environmentConfig', [
    environmentConfigCreate,
    environmentConfigEdit,
    environmentConfigAll
])

    .component('environmentConfig', environmentConfigComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('environment_config.edit', {
                url: '/edit/:id',
                component: 'environmentConfigEdit',
                data: {
                    requireACL: 'tnt_control_environment_config.edit'
                }
            })

            .state('environment_config.create', {
                url: '/create',
                component: 'environmentConfigCreate',
                data: {
                    requireACL: 'tnt_control_environment_config.create'
                }
            })

            .state('environment_config.all', {
                url: '/all/:page',
                component: 'environmentConfigAll',
                data: {
                    requireACL: 'tnt_control_environment_config.view'
                }
            })
    })
    .name;

export default environmentConfigModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/index.js